import React, { Fragment, ReactNode, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { analyticsFEA } from "src/AnalyticsFEA";
import { CONTINUE_DEAL_BASE_PATH } from "src/components/ContinueDeal/constants";
import { updateModalSize } from "src/store/actions/updateModalSize";
import useSelector from "src/utils/useSelector";

const LARGE_MODAL_ROUTES = [
    "/inventory",
    "/my-garage",
    "/my-garage/payment-settings",
    "/my-garage/trade-in",
    "/my-garage/conditional-rebates",
    "/my-garage/accessories",
    "/my-garage/bank-offers",
    "/my-garage/test-drive",
    "/my-garage/test-drive/success",
    "/my-garage/message-center",
    CONTINUE_DEAL_BASE_PATH,
    "/continue-deal/customize-vehicle",
    "/continue-deal/schedule-appointment",
    "/continue-deal/schedule-success",
    "/continue-deal/credit-application",
    "/continue-deal/credit-application/creditiq",
    "/continue-deal/review",
    "/continue-deal/messages",
];

export default function RouteWatcher({ children }: { children: ReactNode }) {
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const { push } = useHistory();
    const routeToSignIn = useSelector((state) => state.onlineShopper.routeSignIn);
    const modalSize = useSelector((state) => state.onlineShopper.modalSize);

    // Responsible for routing to the Sign In screen, because currently out router context isn't available in src/index
    // where we define our signIn window.OnlineShopper api method
    useEffect(() => {
        if (routeToSignIn) {
            push("/access-my-garage");
        }
    }, [routeToSignIn, push]);

    useEffect(() => {
        if (!routeToSignIn && pathname === "/access-my-garage") {
            push("/");
        }
    }, [routeToSignIn, push, pathname]);

    // Responsible for FEA page views
    useEffect(() => {
        if (pathname !== "/") {
            analyticsFEA.engine.virtualPageView(`/online-shopper${pathname}`);
        }
    }, [pathname]);

    // Responsible for resizing the Modal
    useEffect(() => {
        if (pathname === "/") {
            return;
        }

        if (LARGE_MODAL_ROUTES.includes(pathname.toLowerCase())) {
            if (modalSize !== "lg") {
                dispatch(updateModalSize({ size: "lg" }));
            }
        } else {
            if (modalSize !== "sm") {
                dispatch(updateModalSize({ size: "sm" }));
            }
        }
    }, [dispatch, modalSize, pathname]);

    return <Fragment>{children}</Fragment>;
}
